var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['titleBox', {'bg-style': _vm.isShowBg}]},[_c('span',{staticClass:"title-color-box"}),_c('span',{staticClass:"tips",style:(_vm.styleObj ? _vm.styleObj : '')},[_vm._v(_vm._s(_vm.label))]),_vm._t("slotBox")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }